import useSelect from "~components/Form/hooks/useSelect";
import useEstados from "~/fetchs/useEstados";
import prepareForOptions from "~services/utils/prepareForOptions";

const useEstadoForm = (formikRef) => {
  const estadoSelect = useSelect("estado");

  const { estados, loading } = useEstados();

  const estadosOptions = prepareForOptions(estados, "nome", "sigla");

  const handleChangeUf = (uf) => {
    if (!uf) return;

    estadoSelect.upDateValue(uf.value);

    estadoSelect.upDateDefaultValue(uf.value ? uf : "");

    formikRef?.current?.setFieldValue("uf", uf.value, false);
    formikRef?.current?.setFieldValue("ufLabel", uf.label, false);
    formikRef?.current?.setFieldTouched("bairro", true, false);
  };

  return {
    loadingEstado: loading,
    estados: estadosOptions,
    estadoSelect,
    handleChangeUf,
  };
};

export default useEstadoForm;
